import { Modal, Table } from "../../../../components";
import { useAdminStore } from "../../../../store/adminStore";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import ViewMap from "../../../../components/ViewMap";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import {
  handlerCambiarEstado,
  handlerCancelar,
  handlerFinalizarActa,
} from "../../../../handlers/actas.handler";
import { usePodadoresStore } from "../../../../store/podadoresStore";
import { tableDataPodadores } from "../tableDataPodadores";
import useWindowSize from "../../../../hooks/useWindowSize";
import ModalAsignarPodadores from "./ModalAsignarPodadores";
import { useFormActaStore } from "../../../../store/formActaStore";
import StarRating from "../../../../components/StarRating";
import Loading from "../../../../components/Loading";

const ModalFinalizarActa = () => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const { podadores, podadoresSelect, setPodadoresSelect } = usePodadoresStore();
  const { width } = useWindowSize();
  const { defaultValues } = useFormActaStore();

  const [ratings, setRatings] = useState({});
  /* const [podadoresSelect, setPodadoresSelect] = useState([]) */

  const handleRating = (podadorId, value) => {
    setRatings((prev) => ({ ...prev, [podadorId]: value }));
  };

  useEffect(() => {
    if (defaultValues.podadores.length > 0) {
      setPodadoresSelect(defaultValues.podadores);
    }

    return () => {
      setPodadoresSelect([]);
      handlerModal({ modal: false, modalName: "finalizar_acta" });
    };
  }, []);

  return (
    <>
      <Modal
        // fullscreen={true}
        size="md"
        show={modals.includes("finalizar_acta")}
        onHide={() => handlerModal({ modal: false, modalName: "finalizar_acta" })}
        title={() => "Finalizar acta"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100 position-relative"
        >
          {loads.includes("finalizar_acta") && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: "999" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
            </div>
          )}
          <Alert>Agrega un puntaje al servicio de los podadores para finalizar el trámite</Alert>
          <div>
            {defaultValues.podadores.map((podador) => {
              return (
                <div key={podador.id} className="d-flex align-items-center gap-3">
                  <p className="mb-0" style={{ lineHeight: "10px" }}>
                    {podador.nombre}
                  </p>
                  <StarRating
                    rating={ratings[podador.id]}
                    onRate={(value) => handleRating(podador.id, value)}
                  />
                </div>
              );
            })}
            <hr />
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  handlerModal({ modal: false, modalName: "finalizar_acta" });
                }}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success btn-sm"
                onClick={() =>
                  handlerFinalizarActa({ acta_id: defaultValues.id, puntajes: ratings })
                }
              >
                Finalizar trámite
              </button>
            </div>
          </div>
        </motion.div>
        {modals.includes("asignar_podadores") && <ModalAsignarPodadores />}
      </Modal>
    </>
  );
};
export default ModalFinalizarActa;
